import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { AddAreaaInDatabase } from "../../CrudOperations/PostOperation";
import {
  getDistrictList,
  getEventList,
  getSkillList,
  getStateList,
} from "../../CrudOperations/GetOperation";
import { UpdateAreaInDataBase } from "../../CrudOperations/Update&Edit";

const AddArea = ({ closeModal, onSubmit, Area }) => {
  
  const [AreaName, setAreaName] = useState(Area?.AreaName || "");
  const [DistrictId, setDistrictId] = useState(Area?.DistrictId || "");
  const [StateId, setStateId] = useState(Area?.StateId || "");
  const [Pincode, setPincode] = useState(Area?.Pincode || "");
  const [LandMark, setLandMark] = useState(Area?.LandMark || "");
  const [EventDetailsId, setEventDetailsId] = useState(
    Area?.EventDetailId || ""
  );
  const [Status, setStatus] = useState(Area?.Status ?? 0);
  const [EventList, setEventList] = useState([]);
  const [DistrictList, setDistrictList] = useState([]);
  const [StateList, setStateList] = useState([]);
  const [errorMessages, setErrorMessages] = useState([]);
  const [SkillsList, setSkillsList] = useState([]);
  const [DutyStartTime, setDutyStartTime] = useState(
    Area ? Area.StartTime : ""
  );
  const [DutyEndTime, setDutyEndTime] = useState(Area ? Area.EndTime : "");


  const [NoOfDeputation, setNoOfDeputation] = useState("");
  const [DeputationSkills, setDeputationSkills] = useState([]); // Array of selected skills




  useEffect(() => {
    const fetchDropdownData = async () => {
      const [eventRes, districtRes, stateRes, skillRes] = await Promise.all([
        getEventList(),
        getDistrictList(),
        getStateList(),
        getSkillList(),
      ]);

      if (skillRes.data.Message === "Success") {
          setSkillsList(skillRes.data.Data);

      }

      if (eventRes?.data?.Message === "Success") {
        setEventList(eventRes.data.Data);
      }

      if (districtRes?.data) {
        setDistrictList(districtRes.data);
        const pakur = districtRes.data.find((d) => d.DistrictId === 17);
        if (pakur) setDistrictId(pakur.DistrictId);
      }

      if (stateRes?.data) {
        setStateList(stateRes.data);
        const jharkhand = stateRes.data.find((s) => s.StateId === 10);
        if (jharkhand) setStateId(jharkhand.StateId);
      }
    };

    fetchDropdownData();
  }, []);


  useEffect(() => {
    
  if (Area && Area.AreaDeputationSkills) {
    setNoOfDeputation(Area.AreaDeputationSkills.length);
    setDeputationSkills(Area.AreaDeputationSkills.map(s => s || ""));
  }


}, [SkillsList]);


  const handleFormSubmit = async (e) => {
    e.preventDefault();

    // Basic validation
    if (
      !AreaName ||
      !DistrictId ||
      !StateId ||
      !Pincode ||
      !LandMark ||
      !EventDetailsId 
      // !NoOfDeputation 
    ) {
      
      setErrorMessages(["Please fill all required fields."]);
      toast.error("Please fill all required fields.");
      return;
    }

    setErrorMessages([]);

    const payload = {
      AreaName,
      DistrictId: parseInt(DistrictId),
      StateId: parseInt(StateId),
      Pincode: parseInt(Pincode),
      LandMark,
      EventDetailsId: parseInt(EventDetailsId),
      NoOfDeputation: parseInt(NoOfDeputation),
      Skills: DeputationSkills,
      Status: parseInt(Status),
      DutyEndTime,
      DutyStartTime,
    };
    

    try {
      let response;

      if (!Area) {
        response = await AddAreaaInDatabase(...Object.values(payload));
   console.log(response);
   

        if (response.data?.message === "Area added successfully with deputation skills." ||           response.data?.message === "Area added successfully.") {
             console.log(response);
          onSubmit();
        }
        else{

          toast.error(response?.data?.message )


                    toast.error("Something Went Wrong!!");


        }
      } else {
        response = await UpdateAreaInDataBase(
          Area.AreaId,
          ...Object.values(payload)
        );
        
        if (response.data?.ServerMessage == "Area updated successfully.") {
          toast.success("Area updated successfully.");
          onSubmit();
        }

         else   if (response.data?.message == "Area updated successfully.") {
          toast.success("Area updated successfully.");
          onSubmit();
        }

          else if (response.data?.message == "Area updated successfully with deputation skills.") {
          toast.success("Area updated successfully.");
          onSubmit();
        }
      }
    } catch (error) {
            toast.error(error?.response?.data?.message || error?.response?.data?.ServerMessage )
      toast.error("An error occurred. Please try again." , error);

    }
  };

  const handleNumbOfDeputation = (e) => {
    const value = parseInt(e.target.value) || 0;
    setNoOfDeputation(value);

    // Resize DeputationSkills array
    const updated = [...DeputationSkills];
    if (value > updated.length) {
      // Add empty values
      for (let i = updated.length; i < value; i++) {
        updated.push("");
      }
    } else {
      // Trim extra values
      updated.length = value;
    }
    
    setDeputationSkills(updated);
  };

  const handleSkillChange = (index, value) => {
    const updated = [...DeputationSkills];
    updated[index] = value;

    
    setDeputationSkills(updated);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-sm">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg max-h-[90vh] flex flex-col">
        <div className="flex justify-between items-center border-b px-6 pt-6 pb-3">
          <h2 className="text-2xl font-semibold text-blue-700 flex items-center gap-2">
            <svg
              className="w-6 h-6 text-blue-600"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path
                d="M12 4v16m8-8H4"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            {Area ? "Edit Area" : "Add Area"}
          </h2>
          <button
            onClick={closeModal}
            className="text-gray-400 hover:text-red-600 text-xl font-bold"
          >
            &times;
          </button>
        </div>

        {errorMessages.map((msg, index) => (
          <div key={index} className="text-red-500 text-sm mb-2">
            {msg}
          </div>
        ))}

        <div className="overflow-y-auto px-6 pb-4 pt-2 scrollbar-hide">
          <form>
            <div className="mb-2">
              <label className="block text-gray-700">Event Name *</label>
              <select
                value={EventDetailsId}
                onChange={(e) => setEventDetailsId(e.target.value)}
                className="border border-gray-300 p-1 w-full rounded-md"
              >
                <option value="">Select Event</option>
                {EventList.map((event) => (
                  <option key={event.EventDetailId} value={event.EventDetailId}>
                    {event.EventName}
                  </option>
                ))}
              </select>
            </div>

            <div className="mb-2">
              <label className="block text-gray-700">Area Name *</label>
              <input
                type="text"
                value={AreaName}
                onChange={(e) => setAreaName(e.target.value)}
                className="border border-gray-300 p-1 w-full rounded-md"
                required
              />
            </div>

            <div className="mb-2">
              <label className="block text-gray-700">LandMark *</label>
              <input
                type="text"
                value={LandMark}
                onChange={(e) => setLandMark(e.target.value)}
                className="border border-gray-300 p-1 w-full rounded-md"
                required
              />
            </div>

            <div className="mb-2">
              <label className="block text-gray-700">Pincode *</label>
              <input
                type="number"
                value={Pincode}
                onChange={(e) => setPincode(e.target.value)}
                className="border border-gray-300 p-1 w-full rounded-md"
                required
              />
            </div>

            <div className="mb-2">
              <label className="block text-gray-700">District *</label>
              <select
                value={DistrictId}
                disabled
                onChange={(e) => setDistrictId(e.target.value)}
                className="border border-gray-300 p-1 w-full rounded-md"
              >
                <option value="">Select District</option>
                {DistrictList.map((d) => (
                  <option key={d.DistrictId} value={d.DistrictId}>
                    {d.DistrictName}
                  </option>
                ))}
              </select>
            </div>

            <div className="mb-2">
              <label className="block text-gray-700">State *</label>
              <select
                value={StateId}
                disabled
                onChange={(e) => setStateId(e.target.value)}
                className="border border-gray-300 p-1 w-full rounded-md"
              >
                <option value="">Select State</option>
                {StateList.map((s) => (
                  <option key={s.StateId} value={s.StateId}>
                    {s.StateName}
                  </option>
                ))}
              </select>
            </div>

            <div className="mb-2">
              <label className="block text-gray-700">No Of Deputation *</label>
              <input
                type="number"
                value={NoOfDeputation}
                onChange={handleNumbOfDeputation}
                className="border border-gray-300 p-1 w-full rounded-md"
                required
              />
            </div>

            

            {DeputationSkills.map((skill, index) => (
              <div key={index} className="mb-2">
                <label className="block text-gray-700">
                  Skill for Deputation {index + 1} *
                </label>
                <select
                  value={skill}
                  onChange={(e) => handleSkillChange(index, e.target.value)}
                  className="border border-gray-300 p-1 w-full rounded-md"
                >
                  <option value="">Select Skill</option>
                  {SkillsList.map((s, idx) => (
                    <option key={idx} value={s.SkillId}>
                      {s.SkillName}
                    </option>
                  ))}
                </select>
              </div>
            ))}

            <div className="mb-2">
              <label className="block text-gray-700">Duty Start time</label>
              <input
                type="time"
                value={DutyStartTime}
                onChange={(e) => setDutyStartTime(e.target.value)}
                className="border border-gray-300 p-1 w-full rounded-md"
              />
            </div>

            <div className="mb-2">
              <label className="block text-gray-700">Duty End Time</label>
              <input
                type="time"
                value={DutyEndTime}
                onChange={(e) => setDutyEndTime(e.target.value)}
                className="border border-gray-300 p-1 w-full rounded-md"
              />
            </div>

            <div className="mb-2">
              <label className="block text-gray-700">Status *</label>
              <select
                value={Status}
                onChange={(e) => setStatus(e.target.value)}
                className="border border-gray-300 p-1 w-full rounded-md"
              >
                <option value="">Select Status</option>
                <option value={1}>Active</option>
                <option value={0}>Inactive</option>
              </select>
            </div>
          </form>
        </div>

        <div className="flex justify-end gap-3 border-t px-6 py-4 bg-white sticky bottom-0">
          <button
            type="button"
            onClick={closeModal}
            className="px-4 py-2 rounded-md border border-gray-400 text-gray-600 hover:bg-gray-100"
          >
            Cancel
          </button>
          <button
            onClick={handleFormSubmit}
            type="submit"
            form="yourFormId" // optional if you separate form
            className="px-4 py-2 rounded-md bg-blue-600 text-white hover:bg-blue-700"
          >
            {Area ? "Update" : "Submit"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddArea;
